// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2o-2";
export var placeholderIcon = "_2o-3";
export var thumbnailCanvas = "_2o-1";
export var thumbnailWrapper = "_2o-0";